import { render } from "./ForbiddenView.vue?vue&type=template&id=1ac509e2&scoped=true"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import "./ForbiddenView.vue?vue&type=style&index=0&id=1ac509e2&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac509e2"]])

export default __exports__